import z from "zod";

export const productCategorySchema = z.object({
	id: z.number().nullable(),
	name: z.string().min(1).max(255),
});

export type ProductCategorySchemaInput = z.input<typeof productCategorySchema>;
export type ProductCategorySchemaOutput = z.output<typeof productCategorySchema>;
